import moment from 'jalali-moment';
import axios from './index';

export const fetchWithdrawalList = async (page, limit, filters = {}, sort = undefined) => {
  const params = { page, limit, sort };

  if (filters.status) params.status = filters.status; // pending | done | rejected
  if (filters.userId) params.user_id = filters.userId;

  if (filters.startDate || filters.endDate) {
    const dates = [];
    if (filters.startDate) dates.push(`gte:${moment(filters.startDate).format('YYYY-MM-DD')}`);
    if (filters.endDate) dates.push(`lte:${moment(filters.endDate).format('YYYY-MM-DD')}`);
    params.date = dates.join('[and]');
  }

  const { data } = await axios.get(`/withdrawals/admin`, { params });
  return data.data;
};

export const fetchWithdrawalInfo = async (id) => {
  const { data } = await axios.get(`/withdrawals/admin/${id}`);
  return data.data;
};

export const updateWithdrawal = async (id, status, reasonRejected) => {
  const { data } = await axios.put(`/withdrawals/admin/${id}`, { status, reasonRejected });
  return data.messages;
};
